import { render, staticRenderFns } from "./DialogResetPassword.vue?vue&type=template&id=56d98d46&scoped=true"
import script from "./DialogResetPassword.vue?vue&type=script&lang=js"
export * from "./DialogResetPassword.vue?vue&type=script&lang=js"
import style0 from "./DialogResetPassword.vue?vue&type=style&index=0&id=56d98d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d98d46",
  null
  
)

export default component.exports